import { useMemo } from 'react';

import countriesIso from '@/data/countries-iso';
import { useLanguage } from '@/hooks/user';

export function useCountryOptions() {
	const language = useLanguage();

	return useMemo(() => {
		const collator = new Intl.Collator(language);
		const displayName = new Intl.DisplayNames([language], { type: 'region' });

		return countriesIso
			.map(code => ({
				value: code,
				label: displayName.of(code.toUpperCase())
			}))
			.sort((a, b) => collator.compare(a.label, b.label));
	}, [language]);
}
